module.exports = __webpack_public_path__ + "static/media/dextools-logo.159d5915.svg";